import styled, { themeGet } from "@styled";

export const SectionWrap = styled.div`
    background: ${themeGet("colors.primary")};
    padding-block-start: 60px;
    padding-block-end: 30px;
`;
